import * as Sentry from '@sentry/browser'

export default {
  'atlas/syncModel' (state, { path, value }) {
    assign(state, path, value)
  },

  setAlert (state, payload) {
    state.alert = payload
  },
  notify (state, message) {
    state.alert = { message }
  },
  notifyError (state, { message, error }) {
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error)
    } else {
      // eslint-disable-next-line no-console
      console.warn(error)
    }
    state.alert = { message, error: true }
  },
  setAppLoading (state, payload) {
    state.loading = !!payload
  }
}

function assign (obj, prop, value) {
  if (typeof prop === 'string') {
    prop = prop.split('.')
  }

  if (prop.length > 1) {
    const e = prop.shift()
    assign(obj[e] = Object.prototype.toString.call(obj[e]) === '[object Object]'
      ? obj[e] : {},
    prop,
    value)
  } else {
    obj[prop[0]] = value
  }
}
